<template>
<div class="contentBox recordPage">
    <div class="pageTitle">
        <h1>扣费记录</h1>
    </div>
    <div class="decutionListWrap">
        <el-table :data="logs" style="width: 100%" border header-row-class-name="tableHeader" show-summary :summary-method="getSummaries">
            <el-table-column prop="feeTime" label="时间" width="217"></el-table-column>
            <el-table-column prop="formatFlow" label="流量" width="142" align="right"></el-table-column>
            <el-table-column prop="formatSpace" label="空间" width="166" align="right"></el-table-column>
            <el-table-column prop="formatDuration" label="时长" width="150" align="right"></el-table-column>
            <el-table-column prop="memo" label="备注"></el-table-column>
        </el-table>
    </div>

    <div class="paginationBox purchaseHistoryPagination" v-if="pageCount > 1">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[20, 30, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="totalCount" prev-text="上一页" next-text="下一页"></el-pagination>
    </div>
</div>
</template>

<script>
    import common from '../../../common.vue';

    export default {
        name: "Deduction",
        data() {
            return {
                logs: [],
                pageIndex: 1,
                pageSize: 20,
                pageCount: 0,
                totalCount: 0,
                totalFlow: 0,
                totalSpace: 0,
                totalDuration: 0
            };
        },
        methods: {
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            getSummaries() {
                return [
                    "小计",
                    common.formatSize(this.totalFlow).join(' '),
                    common.formatSize(this.totalSpace).join(' '),
                    common.seconds2duration(this.totalDuration),
                    ""];
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.loadLog(this.pageIndex);
            },
            handleCurrentChange(val) {
                this.loadLog(val);
            },
            loadLog(pageIndex){
                let _this = this, index = pageIndex || 1;

                _this.logs = [];
                _this.$axios.post(common._BASE_ + '/feeLog/loadFeeLogs',
                    this.$qs.stringify({pageNo: index, pageSize: _this.pageSize})).then(function (res) {
                    let r = res.data;
                    _this.pageIndex = index;
                    if (r && r.data) {
                        _this.dealLogs(r.data);
                    }
                    _this.totalCount = r.count;
                    _this.pageCount = Math.ceil(r.count / _this.pageSize);
                });
            },
            dealLogs(logs){
                let _this = this;
                _this.totalFlow = 0; _this.totalSpace = 0; _this.totalDuration = 0;
                (logs || []).forEach(function(log){
                    log.formatFlow = common.formatSize(log.flow).join(' ');
                    _this.totalFlow += log.flow;
                    log.formatSpace = common.formatSize(log.space).join(' ');
                    _this.totalSpace += log.space;
                    log.formatDuration = common.seconds2duration(log.duration);
                    _this.totalDuration += log.duration;
                    _this.logs.push(log);
                });
            }
        },

        mounted() {
            this.loadLog(1);
        },
    };
</script> 

<style lang="less">
.recordPage {
    .pageTitle {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;


        .searchBox {
            position: relative;
            display: flex;

            .search {
                width: 437px;
                height: 40px;
                border: solid 1px #e8e8e8;
                background: #fff;
                border-radius: 6px;
                padding-left: 12px;
            }

            .search:focus {
                border: 1px solid #306ff6;
            }
        }

        .buyBtn {
            width: 137px;
            height: 40px;
            background: #076eff;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            margin-left: 10px;

            img {
                margin-right: 6px;
            }
        }

        .buyBtn:hover {
            background: #4aa3f8;
        }
    }

    // .decutionListWrap {
    //     height: 970px;
    // }
}

.el-table__body-wrapper.is-scrolling-none,
.el-table__header {
    border: solid 1px #ebeef5;
}

.el-table__header {
    border-bottom: none;
}

.el-table__body-wrapper.is-scrolling-none {
    border-top: none;
}

.recordPage .el-table__footer td {
    color: #306ff6 !important;
}
</style>